<template>
  <ubi-page-container v-loading="isLoading">
    <template v-slot:page-actions>
      <router-link :to="{ name: 'social-reviews' }"><el-button type="primary">{{ $t('socialReviews.backToReviews') }}</el-button></router-link>
    </template>
    <ubi-panel>
      <template>
        <h1>{{ $t('socialReviews.titleSuggestedReviews') }}</h1>
        <p class="text-suggested-reviews">{{ $t('socialReviews.text1SuggestedReviews') }}</p>
        <p class="text-suggested-reviews">{{ $t('socialReviews.text2SuggestedReviews') }}</p>
        <div class="input-suggest-reviews">
          <el-input type="email" :placeholder="$t('socialReviews.enterMail')" v-model="email" class="mb-3 mt-3"></el-input>
        </div>
        <div class="container-card-suggest-reviews">
          <div v-for="networkSuggested in getListSuggestedReviews" :key="networkSuggested.id">
            <CardSuggestedReviews :networkSuggested="networkSuggested"/>
          </div>
        </div>
        <div class="btn-suggested-reviews mt-5"><el-button type="success" @click="sendFormSuggestedReviews">{{ $t('socialReviews.sendSelected') }}</el-button></div>
      </template>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer'
import UbiPanel from '@/components/Panel'
import CardSuggestedReviews from '@/components/ui/CardSuggestedReviews'
import { validateEmail } from '@/helpers/functions/checkmail'

export default {
  name: 'SuggestedReviews',
  components: { CardSuggestedReviews, UbiPanel, UbiPageContainer },
  data () {
    return {
      email: ''
    }
  },
  watch: {
    getListSuggestedReviews: {
      handler (newValue) {
        this.$store.commit('setListSuggestedReviews', newValue)
      },
      deep: true
    }
  },
  computed: {
    getListSuggestedReviews () {
      return this.$store.getters.getListSuggestedReviews
    },
    isLoading () {
      return this.$store.getters.getIsSuggestedLoadingState
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    sendFormSuggestedReviews () {
      if (this.email !== '' && validateEmail(this.email)) {
        this.$store.dispatch('sendMailForReceiver', { email: this.email })
      } else {
        this.$message({
          type: 'warning',
          message: this.$t('socialReviews.emailIsEmpty')
        })
      }
      this.email = ''
    } 
  },
  mounted () {
    this.$store.dispatch('loadOnlyFacebookAndGoogleMedia')
    this.$store.dispatch('loadListSuggestedReviews', { sitimmoUser: this.sitimmoUser })
  }
}
</script>

<style scoped>
.text-suggested-reviews {
  font-size: 14px;
}
.input-suggest-reviews {
  width: 500px;
}
.container-card-suggest-reviews {
  width: 90%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.btn-suggested-reviews {
  width: 90%;
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
</style>
